import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { PAYMENT_MAKE_PAYMENT } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import PaymentSuccess from '../presentational/PaymentSuccess';
import { setSelectedPayee } from 'lib/slices';

const PaymentSuccessContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const handleSuccessClick = () => {
        navigate(PAYMENT_MAKE_PAYMENT);
    };

    useEffect(() => {
        return () => {
            dispatch(setSelectedPayee(null));
        };
    }, [dispatch]);

    return (
        <PageContainer>
            {location.state?.data && (
                <PaymentSuccess
                    data={location.state.data}
                    onSuccessClick={handleSuccessClick}
                />
            )}
        </PageContainer>
    );
};

export default PaymentSuccessContainer;
